<template>
    <!--    政策解读-列表组件-->
    <ul class="policyList">
        <li v-for="(item,index) in policydata" :key="index" @click="inforClick(index)" 
        :class="(index<policydata.length-1)?'speaceLi':''"
        >
            <div class="policyClassify">
                <p v-if='item.policyTypeName'>{{item.policyTypeName}}</p>
                <el-image :src="item.policyThumbnail" fit="cover"></el-image>
            </div>
            <p class="defaultTitle classifyTitle">{{item.policyName}}</p>
            <div class="timeRead">
                <span class="smallTitle">{{item.createTime | translatDateToDayPointStr}}</span>
                <span class="smallTitle readImg">{{Number(item.readCount || 0)+Number(item.originReadCount || 0) }}</span>
            </div>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "lp-PolicyList",
        props:['policydata'],
        data(){
            return{
                noImg:require('../../assets/images/test.jpg')
            }
        },
        methods:{
            inforClick(index){
                var path=this.policydata[index];
                //查看详情
                this.$router.push({path:"/detail/"+path.id,query:{type:1}})
            }
        }
    }
</script>

<style lang="less" scoped>
    .policyList{
        width: @contentWidth;
        display: flex;
        flex-wrap: wrap;
        // justify-content: space-between;
        @imgWidth:285px;
        .speaceLi{
            margin-right: 20px;
        }
        li{
            cursor: pointer;
            width: @imgWidth;
            height: 270px;
            border-bottom: 1px @lineDefaultColor solid;
            margin-top: 18px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            /*图片*/
            .policyClassify{
                width: @imgWidth;
                height: 188px;
                position: relative;
                overflow: hidden;
                background-color: #79ABE0;
                .el-image{
                    width: @imgWidth;
                    height: 188px;
                    transition: 1s;
                }
                /*鼠标悬浮图片-放大*/
                .el-image:hover {
                    transform: scale(1.2);
                }
                p{
                    position: absolute;
                    left: 10px;
                    top: 10px;
                    z-index: 9;
                    color: #fff;
                    background: rgba(0,0,0,0.5);
                    padding: 4px 10px ;
                    font-size: @fontSmallSize;
                }
            }
            /*标题*/
            .classifyTitle{
                /*最多2行-省略号*/
                text-overflow:ellipsis;
                -webkit-line-clamp: 2;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                overflow: hidden;
                cursor: pointer;
                // width: 100px;
                height: 36px;
                line-height: 18px;
            }
            .classifyTitle:hover{
                color: @hoverDefaultColor;
            }
            /*时间 阅读量*/
            .timeRead{
                display: flex;
                margin-bottom: 10px;
                .readImg{
                    margin-left: 45px;
                    display: flex;
                    align-items: center;
                }
                .readImg:before{
                    content: '';
                    display: block;
                    width: 12.5px;
                    height: 12.5px;
                    background: url("../../assets/images/read.png") no-repeat center;
                    background-size: cover;
                    margin-right: 6.5px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/policylist/index.vue